import {v4 as uuidv4} from 'uuid';
import { randomId as random } from './random.ts';
import UBCore from './ub-core.ts';
import { safeWindow } from '../../../utils/window.ts';

declare global {
    interface Window {
        UB_HTTP_STATUS_CODE: number;
    }
}

export function account(): string {
    return safeWindow()?.location.hostname ?? '';
}

export function isMobile(): boolean {
    return safeWindow()?.matchMedia('only screen and (max-width: 767px)').matches ?? false;
}

export function clientId(): string {
    const clientIdName: string = UBCore.storagePrefix + 'client_id';
    const clientId : string|null = safeWindow()?.localStorage.getItem(clientIdName) ?? null;

    if (!clientId) {
        const newClientId: string = UUID();

        safeWindow()?.localStorage.setItem(clientIdName, newClientId);

        return newClientId;
    }

    return clientId;
}

export function sessionId(): string {
    const sessionIdName: string = UBCore.storagePrefix + 'session_id';
    const sessionId: string|null = safeWindow()?.sessionStorage.getItem(sessionIdName) ?? null;

    if (!sessionId) {
        const newSessionId: string = UUID();

        safeWindow()?.sessionStorage.setItem(sessionIdName, newSessionId);

        return newSessionId;
    }

    return sessionId;
}

export function formatUbrdata(data: object): string {
    return Object.entries(data as Record<string, any>).map(([key, value]: [string, any]) => `${key}=${value}`).join(';');
}

export function formatActiveAbTests(abTests: string[]): string {
    abTests = abTests.map(test => test.replace('=', ':'));
    return abTests.join(',');
}

export function randomId(length: number = 5): string {
    return random(length);
}

export function UUID(): string {
    return uuidv4();
}

export function deviceCategory(): string {
    return isMobile() ? 'mobile' : 'desktop';
}

export function userAgent(): string {
    return safeWindow()?.navigator.userAgent ?? '';
}

export function referrer(): string {
    return safeWindow()?.document.referrer ?? '';
}

export function currentURL(): string {
    return safeWindow()?.location.href ?? '';
}

export function httpStatusCode(): number {
    const statusCode: number|undefined = safeWindow()?.UB_HTTP_STATUS_CODE;

    return (typeof statusCode !== 'undefined') ? statusCode : 200;
}

export function activeAbTests(): string[] {
    const cookies = safeWindow()?.document.cookie.split('; ');
    const abTestsCookies = cookies?.filter(row => row.startsWith(UBCore.abTestsPrefix));

    return abTestsCookies ?? [];
}
